
import { useState, useEffect } from 'react';

interface NavbarProps {
  onApplyClick: () => void;
}

export default function Navbar({ onApplyClick }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img
              src="https://static.readdy.ai/image/38c616fd8ccf1a8e3e37c843eeb88e31/7e733299bbff473d8f94beaff4f3770b.png"
              alt="咲くら庵ロゴ"
              className="h-24 w-auto object-contain"
            />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('features')}
              className="text-sm font-medium text-gray-700 hover:text-pink-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              特長
            </button>
            <button
              onClick={() => scrollToSection('concept')}
              className="text-sm font-medium text-gray-700 hover:text-pink-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              咲くら庵について
            </button>
            <button
              onClick={() => scrollToSection('conditions')}
              className="text-sm font-medium text-gray-700 hover:text-pink-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              勤務条件
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-sm font-medium text-gray-700 hover:text-pink-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              よくある質問
            </button>
            <button
              onClick={onApplyClick}
              className="bg-pink-500 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-pink-600 transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              応募する
            </button>
          </div>

          <button
            onClick={onApplyClick}
            className="md:hidden bg-pink-500 text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-pink-600 transition-all whitespace-nowrap cursor-pointer"
          >
            応募
          </button>
        </div>
      </div>
    </nav>
  );
}
